import BackButtonComponent from "@shared/ui/BackButton"
import Background from "@shared/ui/Background"
import BigHeadingComponent from "@shared/ui/BigHeading"
import Footer from "@shared/ui/Footer"
import Main from "@shared/ui/Main"
import {
  RouteShellContextProvider,
  resolveRouteShellState,
  useRouteShellPathname,
} from "@shared/ui/routeShellContext"
import SideMenu from "@shared/ui/SideMenu"
import type { SiteShellProps } from "@site-types/components/siteShell"

export function SiteShell({ children, page, title }: SiteShellProps) {
  const pathname = useRouteShellPathname()
  const shellState = resolveRouteShellState({ page, pathname })

  const content = (
    <>
      {title ? <BigHeadingComponent>{title}</BigHeadingComponent> : null}
      {children}
    </>
  )

  return (
    <RouteShellContextProvider
      page={page}
      pathname={pathname}
    >
      <div className="relative flow-root min-h-[100dvh]">
        <SideMenu />
        <Main>
          {shellState.currentPage === "index" ? (
            content
          ) : (
            <div
              data-page={shellState.pageClass}
              className={`m-0 max-w-none p-0 ${
                ["calendar", "careers", "company", "work"].includes(shellState.pageClass)
                  ? "max-page:p-0"
                  : "max-page:px-[2rem] max-page:pt-[5rem] max-page:pb-[3rem]"
              }`}
            >
              {content}
            </div>
          )}
          {shellState.currentPage !== "index" ? <Footer /> : null}
        </Main>
        <Background />
      </div>
    </RouteShellContextProvider>
  )
}

export const BigHeading = BigHeadingComponent

export const BackButton = BackButtonComponent
